import { parseJsonObject } from "../../../features/builder.utils";
import { ADD_OPS, DIFF_OPS, FIELD_KEY_RE, ROLE_TYPES } from "./source-field.constants";
import { resultTypeOf } from "./computed-field.utils";

const required = (message) => (value) => (value === undefined || value === null || value === "" ? message : "");

// Mirrors RemSourceFieldCtl.normalize and RemSourceCtl.validateCompute in the backend. Hidden inputs are not checked,
// so each rule only applies to the operation that shows it.
export const computedFieldValidation = {
  base: required("Pick the date to add to."),
  amount: (value, formData) => {
    if (!ADD_OPS.includes(formData.op) || formData.amount_mode === "field") return "";
    const number = Number(value);
    return value !== "" && value !== null && value !== undefined && Number.isInteger(number) && Math.abs(number) <= 1000 ? "" : "Enter a whole number from -1000 to 1000.";
  },
  amount_path: required("Pick the number column."),
  from: (value, formData) => (DIFF_OPS.includes(formData.op) && !value ? "Pick the start date." : ""),
  relation: required("Pick the related records to count."),
  where_text: (value) => (parseJsonObject(value ?? "") === undefined ? "Must be a JSON object, or empty." : ""),
  latest_column: required("Pick the column to read."),
  order_by: (value, formData) => {
    if (!value) return "";
    return String(value).split(".")[0] === String(formData.latest_column ?? "").split(".")[0] ? "" : "Order by a column of the same related record.";
  },
  field_key: (value) => (FIELD_KEY_RE.test(String(value ?? "").trim()) ? "" : "Start with a lowercase letter; use a-z, 0-9 and _ (max 63)."),
  label: (value) => (String(value ?? "").trim().length > 100 ? "Label must be at most 100 characters." : ""),
  field_role: (value, formData) => {
    if (!value || value === "ATTRIBUTE") return "";
    const resultType = resultTypeOf(formData);
    return resultType && !ROLE_TYPES[value]?.includes(resultType) ? `A ${value} field cannot hold this result.` : "";
  },
  sort_order: (value) => {
    if (value === "" || value === null || value === undefined) return "";
    const number = Number(value);
    return Number.isInteger(number) && number >= 0 && number <= 10000 ? "" : "Sort order must be a whole number from 0 to 10000.";
  },
};
